import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MediaService } from '@shared/requests/media.service';

@Pipe({
  standalone: true,
  name: 'secureMedia'
})
export class SecureMediaPipe implements PipeTransform {

  constructor(private apiService: MediaService, private domSanitizer: DomSanitizer) {

  }

  transform(image: any, ...args: any[]): Observable<any>|null {
    if (!image || !image.id) { return null; }
    return this.apiService.getBlob(image).pipe(
      map((res: any) => {
        if (args[0] && args[0][0] === 'noNeedSafe') {
          return res;
        }
        return this.domSanitizer.bypassSecurityTrustUrl(res);
      })
    );

  }

}
